import { 
  collection, 
  addDoc, 
  getDocs, 
  query, 
  where, 
  orderBy,
  serverTimestamp,
  doc,
  updateDoc,
  deleteDoc
} from 'firebase/firestore';
import { db } from '../firebase';

const COLLECTION_NAME = 'logEntries';

// Create a new log entry
export const createLogEntry = async (logEntryData, userId) => {
  try {
    console.log('Creating log entry with data:', logEntryData);
    console.log('User ID:', userId);
    
    const docData = {
      ...logEntryData,
      userId,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp()
    };
    
    console.log('Document data to be saved:', docData);
    
    const docRef = await addDoc(collection(db, COLLECTION_NAME), docData);
    return { 
      id: docRef.id, 
      ...logEntryData,
      createdAt: new Date().toISOString(),
      updatedAt: new Date().toISOString()
    };
  } catch (error) {
    console.error('Error creating log entry:', error);
    console.error('Error details:', error.message, error.code);
    throw new Error(`Failed to create log entry: ${error.message}`);
  }
};

// Get all log entries for a user
export const getLogEntries = async (userId) => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where('userId', '==', userId),
      orderBy('date', 'desc')
    );
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      // Convert Firestore timestamps to ISO strings for consistency
      createdAt: doc.data().createdAt?.toDate?.()?.toISOString() || new Date().toISOString(),
      updatedAt: doc.data().updatedAt?.toDate?.()?.toISOString() || new Date().toISOString()
    }));
  } catch (error) {
    console.error('Error fetching log entries:', error);
    console.error('Error details:', error.message, error.code);
    throw new Error(`Failed to fetch log entries: ${error.message}`);
  }
};

// Get log entries for a specific metric
export const getLogEntriesForMetric = async (metricId, userId) => {
  try {
    const q = query(
      collection(db, COLLECTION_NAME),
      where('userId', '==', userId),
      where('metricId', '==', metricId),
      orderBy('date', 'desc')
    );
    const querySnapshot = await getDocs(q);
    
    return querySnapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt?.toDate?.()?.toISOString() || new Date().toISOString(),
      updatedAt: doc.data().updatedAt?.toDate?.()?.toISOString() || new Date().toISOString()
    }));
  } catch (error) {
    console.error('Error fetching log entries for metric:', error);
    console.error('Error details:', error.message, error.code);
    throw new Error(`Failed to fetch log entries for metric: ${error.message}`);
  }
};

// Update a log entry
export const updateLogEntry = async (entryId, updatedData, userId) => {
  try {
    console.log('Updating log entry:', entryId, updatedData);
    
    const docRef = doc(db, COLLECTION_NAME, entryId);
    const docData = {
      ...updatedData,
      userId,
      updatedAt: serverTimestamp()
    };
    
    await updateDoc(docRef, docData);
    return { id: entryId, ...updatedData };
  } catch (error) {
    console.error('Error updating log entry:', error);
    console.error('Error details:', error.message, error.code);
    throw new Error(`Failed to update log entry: ${error.message}`);
  }
};

// Delete a log entry
export const deleteLogEntry = async (entryId, userId) => {
  try {
    console.log('Deleting log entry:', entryId);
    
    const docRef = doc(db, COLLECTION_NAME, entryId);
    await deleteDoc(docRef);
    return entryId;
  } catch (error) {
    console.error('Error deleting log entry:', error);
    console.error('Error details:', error.message, error.code);
    throw new Error(`Failed to delete log entry: ${error.message}`);
  }
};
